<template>
  <div class="" style="width: 100%; height: 100%; position: relative; overflow: hidden; "
    v-if="options.from_start != null">

    <div ref="scroll_container_wrapper" class="by-scroll-container"
      style="width: 100%;  display: flex; position: relative; overflow-x: scroll; overflow-y:scroll; height: 100%;"
      v-if="options.from_start != null">

    <grid-sidebar :container_height="container_height" :segment_view="segment_view"
      :render_segments="render_segments"
      @update:segment_view="segment_view = $event"
    ></grid-sidebar>

  <div style="position: relative; z-index: 1;" 
    :style="{ 'height': container_height + 'px' }"
  >

<div>

</div>

     <grid-header :match_exact_color="match_exact_color" :background_colors="background_colors" :days_number="days_number" :options="options" :months="months" style=" top:0px; position:sticky"
        :style="{ width: options.day_width * days_number + 'px' }"></grid-header>

      <div class="events-container" ref="container_wrapper" 
        @mousemove="moveEvent($event)" 
        @mouseup="endDrag($event)"
        @mousedown.stop="startDrag(null, $event, null)" style="position: absolute;top: 40px;"
        :style="{ width: options.day_width * days_number + 'px', 'height': container_height + 'px' }">


        <div v-for="(segment) in render_segments" 
            :key="segment.key.team_id + segment.key.team_type"
            style="position: absolute; 
                   border-bottom: 1px solid #eeeeee;
                   width: 100%;"
            :style="{ 'background-color': segment.key.color, 'top': segment.top + 'px', 'height': segment.height + 'px' }">
  
            <grid-view :ref="'grid_view_'+segment.key.team_id + segment.key.team_type"
              :days_number="days_number"
              :options="options"
              :months="months"
              :segment="segment"
              :match_exact_color="match_exact_color"
              :background_colors="background_colors"
              style="height: 100%; top:0px; position:absolute"
              :style="{ width: options.day_width * days_number + 'px' }"
            ></grid-view>

          <grid-event v-for="event in segment.values" :key="event.id" :event="event"
            @startDrag.stop="startDrag(segment, $event, event)" 
            @startResize="startResize($event, event, segment)"
            @open-activities="$emit('open-activities', $event)"
            @open-tasks="$emit('open-tasks', $event)"
            @open-activity="$emit('open-activity', $event)"
            @open-task="$emit('open-task', $event)">
          </grid-event>

        </div>

        <grid-drag-element v-if="drag_element != null && drag_element.moved" 
        :drag_element="drag_element"></grid-drag-element>

      </div>

    </div>
    </div>

  </div>

</template>


<script>
import dayjs from "dayjs";
import "dayjs/locale/it";
import gridView from './grid-view.vue';
import gridHeader from './grid-header.vue';
import gridSidebar from './grid-sidebar.vue';
import gridEvent from './grid-event.vue';
import gridDragElement from './grid-drag-element.vue';
export default {
  components: { gridView, gridHeader, gridSidebar, gridEvent, gridDragElement },
  name: "gant-board",
  props: ["elements", "team_members", "from_start", "to_start", "background_colors","enable_new", "match_exact_color"],
  data() {
    return {
      segment_view: true,
      group_by: "u",
      render_segments: [],
      end_calc: true,
      drag_element: null,
      range: {
        start: new Date(2020, 0, 6),
        end: new Date(2020, 0, 23),
      },
      options: {
        gray_days: [0, 6],
        day_width: 60,
        from_start: null,
        to_start: null,
      },
      resize_event: null,
      color: ["#f44336",
        "#e81e63",
        "#9c27b0",
        "#673ab7",
        "#3f51b5",
        "#2196f3",
        "#03a9f4",
        "#00bcd4",
        "#009688",
        "#4caf50",
        "#8bc34a",
        "#cddc39",
        "#ffeb3b"],
    };
  },
  watch:{
    // elements: {
    //   deep: true,
    //   handler() {
    //     this.render();
    //   },
    // },
  },
  computed: {
    container_height: function () {
      if (this.render_segments.length == 0) {
        return 800;
      }
      return Math.max(...this.render_segments.map(x => x.top + x.height ));
    },
    days_number: function () {
      return this.options.to_start.diff(this.options.from_start, "days") + 1;
    },
    months: function () {
      var months = [];
      var start = this.options.from_start;
      var end = false;
      var index = 0;
      while (!end) {
        var length = start.daysInMonth();
        if (months.length == 0) {
          //console.log(start.startOf("month").add(1, "months").diff(start, "days"));
          length = start.startOf("month").add(1, "months").diff(start, "days")-1;
        }
        months.push({
          index: index,
          name: start.format("MMMM"),
          length: length,
        });
        start = start.add(1, "months");
        index++;
        if (start > this.options.to_start) {
          end = true;
        }
      }

      return months;
    },
  },
  methods: {
    getBackgroundColor(segmentid, segmenttype, dateStr) {
      console.log(segmentid);
      console.log(segmenttype);
       console.log(dateStr);
      if (!this.background_colors) return null;
      for (const bg of this.background_colors) {
        if (dateStr >= bg.start && dateStr <= bg.end) {
          return bg.color;
        }
      }
      return null;
    },
    getDay(index) {
      return this.options.from_start.add(index, "days");
    },
    refresh_render(segment) {
      var ordered = segment.values
        .sort((a, b) => (a.order - b.order));
      //segment.values = [];
      for (let el of ordered) {
        el.row = -1;
      }
      for (let el of ordered) {
        this.refresh_event(segment, el);
        //segment.values.push(this.build_event(segment, el));
      }

    },
    refresh_event(segment, event) {
      var near_element = [...segment.values]
        .filter(
          (x) =>
            x.start < event.end.add(1, "days") && event.start < x.end.add(1, "days") &&
            x.id != event.id
        )
        .map((x) => x.row);

      var row = 0;

      if (near_element.length > 0) {
        row = Math.max(...near_element) + 1;
      }
      event.row = row;
      event.order = row;
      event.top = (35 * row) + 5;
      event.left =
        (event.start.diff(this.options.from_start, "days") - 1) *
        this.options.day_width +
        2;
      event.width =
        (event.end.diff(event.start, "days") + 1) * this.options.day_width - 3;
    },
    async render() {
      this.options.from_start = dayjs(this.from_start);
      this.options.to_start = dayjs(this.to_start);

      var ordered = this.elements
        .filter((x) => x.start != null && x.end != null)
        .sort((a, b) => a.order - b.order);

      if (this.group_by != null && this.group_by == "u") {
        
        this.render_segments = [];
        await this.$nextTick();

        for (var s of this.team_members) {
          this.render_segments.push({ 
              key: s,
              index: this.render_segments.length,
              top: 0,
              height: 0,
              values: [],
              raw: []
            });
        }


        for (var t of ordered) {
          let groupKey = this.team_members.find(x => x.team_id == t.team_id && x.team_type == t.team_type);
          var group = this.render_segments.find(x => x.key == groupKey)
          if (group == null) {
            group = {
              key: groupKey,
              index: this.render_segments.length,
              top: 0,
              height: 0,
              values: [],
              raw: []
            }
            this.render_segments.push(group);
          }
          group.raw.push(t);
        }
        for (var seg of this.render_segments) {
          let order_index = 0;
          for (var el of seg.raw.sort((a, b) => a.order - b.order)) {
            if (el.order === undefined) {
              el.order = order_index;
              order_index++;
            }
            seg.values.push(this.build_event(seg, el));
          }
        }
      }
      this.set_segments_height();
    },
    build_event(group, event) {
      var event_start = dayjs(event.start, "YYYY-MM-DD", true);
      var event_end = dayjs(event.end, "YYYY-MM-DD", true);
      var near_element = group.values
        .filter((x) => x.start < event_end.add(1, "days") && event_start < x.end.add(1, "days"))
        .map((x) => x.row);

      var row = 0;

      if (near_element.length > 0) {
        row = Math.max(...near_element) + 1;
      }

      var prec_group = null;
     group.top = 0;

      if (group.index > 0) {
        prec_group = this.render_segments[group.index - 1];
      }

      if (prec_group != null) {
        group.top = prec_group.height + prec_group.top + 0;
      }

      var now_h = ((row + 1) * 35) + 7;

      group.height = now_h > group.height ? now_h : group.height;

      event.order = row;
        
      // Raggruppa attività e incarichi per giorno (data stringa)
      let dayItemsMap = new Map(); // Mappa: dateStr -> { positionLeft, width, activities: [], tasks: [] }

      if (event.activities && Array.isArray(event.activities)) {
        event.activities.forEach(activity => {
          let activityDate = dayjs(activity.date, "YYYY-MM-DD", true);
          if (activityDate >= event_start && activityDate <= event_end) {
            let dateStr = activityDate.format("YYYY-MM-DD");
            let positionLeft = (activityDate.diff(event_start, "days")) * this.options.day_width;
            if (!dayItemsMap.has(dateStr)) {
              dayItemsMap.set(dateStr, { 
                positionLeft: positionLeft, 
                width: this.options.day_width, 
                activities: [], 
                tasks: [] });
            }
            dayItemsMap.get(dateStr)
            .activities.push({
              name: activity.name,
              date: activity.date,
              id: activity.id
            });
          }
        });
      }

      if (event.tasks && Array.isArray(event.tasks)) {
        event.tasks.forEach(task => {
          let taskDate = dayjs(task.date, "YYYY-MM-DD", true);
          if (taskDate >= event_start && taskDate <= event_end) {
            let dateStr = taskDate.format("YYYY-MM-DD");
            let positionLeft = (taskDate.diff(event_start, "days")) * this.options.day_width;
            if (!dayItemsMap.has(dateStr)) {
              dayItemsMap.set(dateStr, { positionLeft: positionLeft, width: this.options.day_width, activities: [], tasks: [] });
            }
            dayItemsMap.get(dateStr).tasks.push({
              name: task.name,
              id: task.id
            });
          }
        });
      }

      // Converti la mappa in un array ordinato per posizione
      let dayItems = Array.from(dayItemsMap.values()).sort((a, b) => a.positionLeft - b.positionLeft);
   
      let ev = {
        id: event.id,
        name: event.name,
        team_type: event.team_type,
        team_id: event.team_id,
        contact: event.contact,
        start: event_start,
        end: event_end,
        weigth: event.weigth,
        row: row,
        order: event.order,
        top: (35 * row) + 5,
        color: event.color,
        left: ((event_start.diff(this.options.from_start, "days") - 1) * this.options.day_width) + 2,
        width: ((event_end.diff(event_start, "days") + 1) * this.options.day_width) - 3,
        hover: false,
        oncreation: event.oncreation,
        ondrag: false,
        image: event.image,
        dayItems: dayItems,
      };


      return ev;
    },
    startResize(mouseevent, event, segment) {
      this.resize_event = event;
      this.resize_event.segment = segment;
    },
    stopDrag() {
        this.render();
        this.resize_event = null;
        this.drag_element = null;
    },
    startDrag(segment, mouseevent, event) {

      console.log("start drag", mouseevent);

      try{
        if (mouseevent.srcElement._prevClass == "icon task-icon" 
          || mouseevent.srcElement._prevClass == "icon activity-icon" 
          || mouseevent.srcElement.parentElement._prevClass == "icon task-icon" 
          || mouseevent.srcElement.parentElement._prevClass == "icon activity-icon" 
    ){
        return;
      }
      }catch(e){
        console.log(e);
      } 




      let bounds = this.$refs.container_wrapper.getBoundingClientRect();

      if (event == null) {
        if (!this.enable_new) return;
        //creazione nuovo elemento da zero
        var day = Math.round(
          (mouseevent.clientX - bounds.left) / this.options.day_width
        );
        var id = this.elements.length + 1;
        var cur_y = Math.floor((mouseevent.clientY - bounds.top - 0));
        var current_segment = this.render_segments.find(x => x.top < cur_y && (x.top + x.height) > cur_y);
        let n_event = {
          id: null,
          team_type: current_segment.key.team_type,
          team_id: current_segment.key.team_id,
          name: "Nuovo incarico",
          contact: "",
          start: this.options.from_start.add(day + 1, "days").format("YYYY-MM-DD"),
          end: this.options.from_start
            .add(day + 2, "days")
            .format("YYYY-MM-DD"),
          weigth: id,
          order: current_segment.values.length,
          oncreation: true,
          color: this.color[this.getRandomInt(0, 12)],
          image: "",
        };
        this.elements.push(n_event);
        var new_event = this.build_event(current_segment, n_event);
        current_segment.values.push(new_event);
        this.resize_event = new_event;
        this.resize_event.segment = current_segment;
        this.resize_event.end = this.options.from_start.add(day + 2, "days");
        return;
      }

      var event_start = dayjs(event.start, "YYYY-MM-DD", true);
      var event_end = dayjs(event.end, "YYYY-MM-DD", true);
      event.ondrag = true;
      this.drag_element = {
        id: event.id,
        event: event,
        moved: false,
        segment: segment,
        name: event.name,
        contact: event.contact,
        start: event_start,
        end: event_end,
        ondrag: true,
        top: mouseevent.clientY - mouseevent.offsetY - bounds.top,
        offset_position_x: mouseevent.offsetX,
        offset_position_y: mouseevent.offsetY,
        left: (event_start.diff(this.options.from_start, "days") - 1) * this.options.day_width,
        width: (event_end.diff(event_start, "days") + 1) * this.options.day_width,
        color: event.color,
        image: event.image,
        original_order: event.order,
      };

    },
    set_segments_height() {
      var index = 0;
      for (let segment of this.render_segments) {
        var prec_group = null;
        if (index > 0) {
          prec_group = this.render_segments[index - 1];
        }
        if (prec_group != null) {
          segment.top = prec_group.height + prec_group.top + 0;
        }

        if (segment.values.length == 0){
          segment.height = 90;
          index++;
          continue;
        }

        segment.height = (Math.max(...segment.values.map(x => x.row)) + 1) * 35 + 7 ;

        if (segment.height < 90){
          segment.height = 90;
        } 

        index++;
      }

  
    },
    calculateVerticalOrder(mouseevent, bounds, segment) {
      // Calcola in quale "riga" virtuale si trova il mouse
      const relative_y = mouseevent.clientY - bounds.top - segment.top - 17.5;
      const virtual_row = Math.round(relative_y / 35);
      return Math.max(0, virtual_row);
    },
    moveEvent(mouseevent) {

      let bounds = this.$refs.container_wrapper.getBoundingClientRect();

      var day = Math.round(
        (mouseevent.clientX - bounds.left - (this.drag_element?.offset_position_x ?? 0)) /
        this.options.day_width
      );

      if (this.resize_event != null) {
        day = Math.round(
          (mouseevent.clientX - bounds.left) / this.options.day_width
        ) +1 ;
        this.resize_event.end = this.options.from_start.add(day - 1, "days") ;
        this.refresh_render(this.resize_event.segment);

        this.set_segments_height();
        return;
      }

      if (this.drag_element != null) {
     
        this.drag_element.left =
          mouseevent.clientX -
          bounds.left -
          this.drag_element.offset_position_x;

        this.drag_element.top =
          mouseevent.clientY -
          this.drag_element.offset_position_y -
          (bounds.top);

        if (this.drag_element.segment == null) {
          var drag_to_cur_y = Math.floor((mouseevent.clientY - bounds.top - 0));
          var drag_to_current_segment = this.render_segments.find(x => x.top < drag_to_cur_y && (x.top + x.height) > drag_to_cur_y);
          if (drag_to_current_segment != null) {
            this.drag_element.event.start = "1900-01-01";
            this.drag_element.event.end = "1900-01-06";
            var new_event = this.build_event(drag_to_current_segment, this.drag_element.event);
            new_event.ondrag = true;
            this.drag_element.segment = drag_to_current_segment;
            this.drag_element.segment.values.push(new_event);
          }
        }

        var original_event = this.drag_element.segment.values.find(
          (x) => x.id == this.drag_element.id
        );

        if (original_event == null) {
          //sto trascinando un nuovo elemento
          var _original_event = this.elements.find(
            (x) => x.id == this.drag_element.id
          );
          _original_event.start = "1900-01-01";
          _original_event.end = "1900-01-06";
          this.build_event(_original_event);

          this.drag_element.width =
            (original_event.end.diff(original_event.start, "days") - 1) *
            this.options.day_width;
        }

        //determino nuovo inizio e nuova fine
        var duration = original_event.end.diff(original_event.start, "days");
        original_event.start = this.options.from_start.add(day + 1, "days");
        original_event.end = original_event.start.add(duration, "days");

        if (this.drag_element.start != original_event.start || this.drag_element.end != original_event.end){
          this.drag_element.moved = true;
        }   

        this.drag_element.start = original_event.start;
        this.drag_element.end = original_event.end;

        

        //spostamento su nuovo segmento
        var cur_y = Math.floor((mouseevent.clientY - bounds.top - 0));
        var current_segment = this.render_segments.find(x => x.top < cur_y && (x.top + x.height) > cur_y);
        if (current_segment != null) {
          // Se è un segmento diverso, rimuovi dall'vecchio segmento
          if (current_segment != this.drag_element.segment) {
            this.drag_element.segment.values.splice(this.drag_element.segment.values.indexOf(original_event), 1);
            this.drag_element.segment = current_segment;
            this.drag_element.segment.values.push(original_event);
          }
          
          // Logica di riordino verticale
          var target_vertical_order = this.calculateVerticalOrder(mouseevent, bounds, current_segment);
        
          
          original_event.order = target_vertical_order;

          // Ordina gli elementi dello stesso periodo per il riordino verticale
          const events_in_period = current_segment.values.filter(
            (x) => x.start < original_event.end 
              && original_event.start < x.end 
              && x.id != original_event.id
          ).sort((a, b) => a.order - b.order);

          // Inizializza un contatore per il nuovo ordine verticale (che salterà l'original_event)
          let current_order_index = events_in_period[0] ? events_in_period[0].order : 0; 
          
          for (const event_to_update of events_in_period) {
               // Se l'indice corrente è uguale al target dell'original_event, 
               // significa che lo slot è occupato da 'original_event'.
               // Quindi, salta questo indice e incrementa il contatore.
               if (current_order_index === target_vertical_order) {
                   current_order_index++;
               }

               // Se l'indice corrente è diverso dal target o abbiamo saltato lo slot, 
               // aggiorna l'ordine dell'evento sovrapposto.
               
               var el = this.elements.find(x => x.id === event_to_update.id);
               
               if (el) {
                   el.order = current_order_index;
                   event_to_update.order = current_order_index;
               }

               // Incrementa l'indice per il prossimo evento sovrapposto
               current_order_index++;
          }


        }

        this.refresh_render(this.drag_element.segment);
        this.set_segments_height();

      }
    },
    endDrag() {
      if (this.resize_event != null && this.resize_event.oncreation == true) {
        this.$emit("new-event", this.resize_event);
        console.log("New event created:", this.resize_event);
        this.resize_event.oncreation = false;
        var new_element = this.elements.find(x => x.id == null);
        this.elements.splice(this.elements.indexOf(new_element), 1);
        this.render();
        this.resize_event = null;
        this.drag_element = null;
        return;
      }

      if (this.resize_event != null) {
        this.$emit("change-event", this.resize_event);
        this.resize_event = null;
        this.drag_element = null;
        return;
      }

      this.resize_event = null;

      if (this.drag_element != null) {

        if (!this.drag_element.moved) {
          this.$emit("open-event", this.drag_element);
        }else{
          this.$emit("change-event", this.drag_element);
        }
    
        var original_event = this.drag_element.segment.values.find(
          (x) => x.id == this.drag_element.id
        );
        original_event.ondrag = false;
        
        // Persisti l'ordine nell'elemento originale
        var original_element = this.elements.find((x) => x.id == this.drag_element.id);
        if (original_element) {
          original_element.order = original_event.order;
        }
      }
      this.drag_element = null;
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
    },
  },
  created() { },
  mounted() {
    dayjs.locale("it");
    this.options.from_start = dayjs(this.from_start);
    this.options.to_start = dayjs(this.to_start);
    
    //this.render();

    this.$nextTick(async () => {

      await new Promise(r => setTimeout(r, 500));

      if (this.render_segments.length > 0){
        let grid_view_ref = this.$refs['grid_view_' + this.render_segments[0].key.team_id + this.render_segments[0].key.team_type];
        if (grid_view_ref && grid_view_ref.length > 0) {
          grid_view_ref[0].scrollToDay(this.$refs.scroll_container_wrapper);
        }
      }

      this.$refs.scroll_container_wrapper.onscroll = () => {
         if (this.$refs.scroll_container_wrapper.scrollLeft == 0) {
           var cur_scroll = this.$refs.scroll_container_wrapper.scrollWidth;
           
           this.options.from_start = this.options.from_start.add(-1, "months");
           this.$emit("update:from_start", this.options.from_start.format("YYYY-MM-DD"));
          
           this.$nextTick(() => {
             var diff = this.$refs.scroll_container_wrapper.scrollWidth - cur_scroll;
             this.$refs.scroll_container_wrapper.scrollLeft = diff;
             this.render();
           });
         }

         if (this.$refs.scroll_container_wrapper.scrollLeft + this.$refs.scroll_container_wrapper.offsetWidth > (this.$refs.scroll_container_wrapper.scrollWidth - 2)) {
           this.options.to_start = this.options.to_start.add(1, "months");
           this.$emit("update:to_start", this.options.to_start.format("YYYY-MM-DD"));
           this.render();
         }
      };
    });

  },
};
</script>

<style scoped>
.events-container {
  height: 200px;
  height: 100%;
  position: relative;
}


.event .event_drag {
  min-width: 10px;
}

.event_title {
  flex-grow: 1;
  text-align: start;
  min-width: 0px;
  font-size: 12px;
}

.event:hover {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.hide {
  min-width: 55px !important;
}

.hide_segment {
  --translate-x: 0px !important;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}



.by-scroll-container::-webkit-scrollbar-track {
  background-color: #fff;
}

.by-scroll-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #F5F5F5;
}

.by-scroll-container::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #999;
}
</style>